import React, { useContext, useState } from 'react';
import _ from 'lodash';

import LegoAdminPageContext from '../../pages/legoAdminPageContext';
import TemplatedFuseboxDiagram from '../lego/fusebox-editor/TemplatedFuseboxDiagram';
import { IconButton } from '../common/IconButton';
import LegoEditButton from '../lego/LegoEditButton';

// Matches /[locale?]/{make}/{model}/[info-segment]/(fusebox|fusibles)/{year}[/{slug}]
const FUSEBOX_URL_RE = /(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/([^/]+)\/([^/]+)\/[^/]+\/(?:fusebox|fusibles)\/(\d{4})(?:\/([^/?#]+))?/i;

export function parseFuseboxFeedbackUrl(url) {
  if (!url) return null;
  const cleanUrl = url.replace(/^https?:\/\/[^/]+/, '');
  const m = cleanUrl.match(FUSEBOX_URL_RE);
  if (!m) return null;
  return { make: m[1], model: m[2], year: parseInt(m[3], 10), slug: m[4] || null };
}

export default function FuseboxFeedbackPreview({ feedbackContext, idModelo }) {
  const { page } = useContext(LegoAdminPageContext);
  const [open, setOpen] = useState(false);
  const [boxes, setBoxes] = useState(null);
  const [status, setStatus] = useState(null);
  const [legoId, setLegoId] = useState(null);

  const parsed = parseFuseboxFeedbackUrl(feedbackContext?.url);
  if (!parsed) return null;

  const togglePreview = async () => {
    if (open) {
      setOpen(false);
      return;
    }
    setOpen(true);
    
    if (boxes) 
      return;

    setStatus('Loading…');
    try {
      const key = idModelo || `${parsed.make}-${parsed.model}`;
      const stableUrls = await page.service('/services/stable-urls/collection').find({
        query: { type: 'fusebox', key, locale: window.config.locale },
      });

      const yearStr = String(parsed.year);
      let match;
      if (parsed.slug) {
        match = _.find(stableUrls, u => u.url === `${yearStr}/${parsed.slug}`);
      }
      if (!match) {
        match = _.find(stableUrls, u => u.url === yearStr || u.url.startsWith(`${yearStr}/`));
      }

      if (!match) { setStatus('No fusebox found for this URL'); return; }

      const lego = await page.service('services/legos').get(match.id);
      const fb = lego?.data;
      if (!fb) { setStatus('Fusebox lego has no data'); return; }

      setLegoId(lego._id);
      setBoxes(fb);
      setStatus(null);
    } catch (err) {
      console.error(err);
      setStatus('Error loading fusebox');
    }
  };

  return <>
    <IconButton small icon={open ? 'visibility_off' : 'visibility'} onClick={togglePreview}>
      {open ? 'Hide preview' : 'Preview'}
    </IconButton>

    {open && legoId ? <LegoEditButton legoId={legoId}>Open lego</LegoEditButton> : null}

    {open && <div className={'mt-1'}>
      {boxes?.length ? boxes.map(box => <div key={box._id} style={{ height: '200px', width: '200px', display: 'inline-block' }}>
            <TemplatedFuseboxDiagram hideTitle fusebox={box} />
            </div>) : <div className={'text-secondary text-center'}>{status}            
          </div>}
    </div>}    
  </>;
}
